import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";

import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CategoryIcon from "@material-ui/icons/Category";
import ImageIcon from "@material-ui/icons/Image";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Chip from "@material-ui/core/Chip";

import ActionFormButton from "../../../common/ActionFormButton";

import {
  renderRowWithTwoItems,
  getRowItemObject,
  Wrapper,
  renderRowWithSelect,
  renderRowWInputNCheckbox,
  Row,
  renderRowWithSingleItem,
} from "../../../common/FormUtils";
import { Plan, PlanCategory, PlanType } from "../../../../types/Plan";
import {
  getSubcategoriesFor,
  findSubcategoryById,
} from "../../../../data/planSubcategories";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Author } from "../../../../types/Author";
import DayPlanTable from "../dayplan";
import { DayPlan } from "../../../../types/DayPlan";
import fetchDayPlans from "../../../../database/dayPlans/fetchDayPlans";
import InputWithCreation from "../components/InputWithCreation";
import createCategory from "../../../../database/planCategories/createCategory";
import ImageUpload from "../../../common/ImageUpload";
import ImportDayPlan from "../components/ImportDayPlan";
import ExportExcel from "../../customers/components/storeCustomers/components/ExportExcel";

const PLAN_LEVEL_OPTIONS = [
  { id: "BEGINNER", title: "Beginner" },
  { id: "INTERMEDIATE", title: "Intermediate" },
  { id: "ADVANCED", title: "Advanced" },
];

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px 0;
`;

const SectionCard = styled(Paper)`
  padding: 24px;
  border-radius: 12px;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

const SectionTitle = styled(Typography)`
  font-weight: 600;
  color: #1a1a2e;
`;

const SectionSubtitle = styled(Typography)`
  color: #6b7280;
  margin-top: 4px;
`;

const DayPlansHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

const DayPlansActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const StatsChip = styled(Chip)`
  background-color: #e0e7ff;
  color: #4338ca;
  font-weight: 500;
`;

const CategoryContainer = styled.div`
  margin-top: 8px;
`;

const ImageUploadContainer = styled.div`
  margin-top: 8px;
`;

type Props = {
  setFieldValue: Function;
  onChageFormToEditMode: Function;
  onEditPassword: Function;
  handleSubmit: Function;
  onRemoveItem: Function;
  isSubmitting: boolean;
  item: any;
  mode: string;
  errors: any;
  values: any;
  authors: Author[];
  categories: PlanCategory[];
  plans: Plan[];
  communityId: string;
};

type State = {
  isPasswordDialogOpen: boolean;
  isRecurringEvent: boolean;
  categoriesCreated: PlanCategory[];
};

class UserForm extends Component<Props, State> {
  state = {
    isPasswordDialogOpen: false,
    isRecurringEvent: false,
    categoriesCreated: [],
  };
  componentDidMount() {
    console.log("[PlanForm] mount", {
      authorId: this.props.values.authorId,
      itemAuthorId: this.props.item?.authorId,
      itemRef: this.props.item,
    });
    this.loadDayPlans();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.values.authorId !== this.props.values.authorId) {
      console.log("[PlanForm] authorId changed", {
        from: prevProps.values.authorId,
        to: this.props.values.authorId,
      });
    }
    if (prevProps.item !== this.props.item) {
      console.log("[PlanForm] item prop reference changed (will reinitialize)", {
        prevAuthorId: prevProps.item?.authorId,
        nextAuthorId: this.props.item?.authorId,
      });
    }
  }

  loadDayPlans = async () => {
    const dayPlans = await fetchDayPlans({ planID: this.props.values.id });
    // Assuming you have a method in your props to update the form values
    this.props.setFieldValue("dayPlans", dayPlans);
  };
  onTogglePassowordDialog = (): void => {
    const { isPasswordDialogOpen } = this.state;

    this.setState({
      isPasswordDialogOpen: !isPasswordDialogOpen,
    });
  };

  onChangePassword = (newPassword: string): void => {
    const { onEditPassword } = this.props;

    this.setState(
      {
        isPasswordDialogOpen: false,
      },
      () => onEditPassword(newPassword)
    );
  };

  renderPasswordSection = (): Object => {
    const passwordConfirmInputFieldData = getRowItemObject(
      "Repeat the Password",
      "Enter the Password again.",
      "password",
      "passwordConfirm"
    );
    const passwordInputFieldData = getRowItemObject(
      "Password",
      "Enter the Password",
      "password",
      "password"
    );

    return (
      <SectionCard elevation={1}>
        <SectionHeader>
          <InfoOutlinedIcon style={{ color: "#6366f1" }} />
          <div>
            <SectionTitle variant="h6">Password</SectionTitle>
            <SectionSubtitle variant="body2">
              Set a password for this plan
            </SectionSubtitle>
          </div>
        </SectionHeader>
        {renderRowWithTwoItems(
          passwordInputFieldData,
          passwordConfirmInputFieldData,
          this.props
        )}
      </SectionCard>
    );
  };

  renderEditPasswordButton = (): Object => (
    <Button
      onClick={() => this.onTogglePassowordDialog()}
      disableRipple
      color="primary"
      variant="contained"
      size="large"
    >
      Edit Password
    </Button>
  );

  renderEventInfoSection = (): Object => {
    const nameInputFieldData = getRowItemObject(
      "Title",
      "Type the title of the plan",
      "text",
      "title"
    );

    const isActiveInput = getRowItemObject(
      "Is the plan active?",
      "",
      "checkbox",
      "isActive"
    );
    const descriptionInputFieldData = getRowItemObject(
      "Description",
      "Type the description of the plan",
      "textarea",
      "description"
    );
    const authorInputFieldData = getRowItemObject(
      "Author",
      "",
      "string",
      "authorId"
    );

    const positionInputFieldData = getRowItemObject(
      "Position",
      "",
      "number",
      "position"
    );
    const levelInputFieldData = getRowItemObject(
      "Learning level",
      "Select the assumed knowledge level",
      "string",
      "level"
    );
    const variantGroupInputFieldData = getRowItemObject(
      "Difficulty variant family",
      "Use the same stable id on Beginner, Intermediate, and Advanced versions of one course. Leave blank for standalone plans.",
      "text",
      "learningVariantGroupId"
    );

    const shortDescriptionInputFieldData = getRowItemObject(
      "Short description",
      "Type the short description of the plan",
      "text",
      "shortDescription"
    );

    return (
      <SectionCard elevation={1}>
        <SectionHeader>
          <InfoOutlinedIcon style={{ color: "#6366f1" }} />
          <div>
            <SectionTitle variant="h6">Plan Details</SectionTitle>
            <SectionSubtitle variant="body2">
              Configure the basic information for this plan
            </SectionSubtitle>
          </div>
        </SectionHeader>
        {renderRowWInputNCheckbox(
          nameInputFieldData,
          isActiveInput,
          this.props
        )}
        {renderRowWithTwoItems(
          descriptionInputFieldData,
          shortDescriptionInputFieldData,
          this.props
        )}
        {renderRowWithSelect(
          { ...authorInputFieldData, subfield: "fullName", savedField: "id" },
          this.props.authors,
          this.props
        )}
        {renderRowWithSelect(
          { ...levelInputFieldData, placeholder: "Select a learning level" },
          PLAN_LEVEL_OPTIONS,
          this.props
        )}
        {renderRowWithSingleItem(variantGroupInputFieldData, this.props)}
        {renderRowWithSingleItem(positionInputFieldData, this.props)}
      </SectionCard>
    );
  };

  setActiveDayOfWeek = (index) => {
    const { values, setFieldValue } = this.props;
    const daysOfWeek = values["recurringDate"]["daysOfWeek"].map(
      (dayOfWeek, _index) => {
        if (index === _index) {
          return { ...dayOfWeek, isActive: !dayOfWeek.isActive };
        }

        return dayOfWeek;
      }
    );

    setFieldValue("recurringDate", {
      ...values["recurringDate"],
      daysOfWeek,
    });
  };

  setDayOfWeekTime = (index, time) => {
    const { values, setFieldValue } = this.props;
    const daysOfWeek = values["recurringDate"]["daysOfWeek"].map(
      (dayOfWeek, _index) => {
        if (index === _index) {
          return { ...dayOfWeek, time };
        }

        return dayOfWeek;
      }
    );

    setFieldValue("recurringDate", {
      ...values["recurringDate"],
      daysOfWeek,
    });
  };

  onSubmitForm = () => {
    const { values, authors } = this.props;
    console.log("[PlanForm] onSubmitForm values", {
      authorId: values.authorId,
      authorName: values.authorName,
      author: values.author,
      matchedAuthor: (authors || []).find((a) => a.id === values.authorId),
      fullValues: values,
    });
    this.props.handleSubmit();
  };
  renderImageSection = () => (
    <SectionCard elevation={1}>
      <SectionHeader>
        <ImageIcon style={{ color: "#6366f1" }} />
        <div>
          <SectionTitle variant="h6">Cover Image</SectionTitle>
          <SectionSubtitle variant="body2">
            Upload a cover image for this plan
          </SectionSubtitle>
        </div>
      </SectionHeader>
      <ImageUploadContainer>
        {this.renderImageField()}
      </ImageUploadContainer>
    </SectionCard>
  );
  renderImageField = () => {
    const coverInputFieldData = getRowItemObject(
      "",
      "Selecciona una imagen de portada para mostrar",
      "file",
      "coverImageURL"
    );

    return (
      <Field name="coverImageURL">
        {({ field, form }) => (
          <ImageUpload
            field={field}
            form={form}
            actionId={this.props.values?.id}
            reference={"plans"}
          />
        )}
      </Field>
    );
  };
  renderDayPlan = () => {
    const { setFieldValue, values, authors } = this.props;
    const dayPlansArray: DayPlan[] = Object.values(values["dayPlans"] || []);
    const dayPlansCount = dayPlansArray.length;

    const authorName =
      (authors || []).find((author) => author.id === values["authorId"])
        ?.fullName || "";
    const authorDescription =
      (authors || []).find((author) => author.id === values["authorId"])
        ?.description ||
      (authors || []).find((author) => author.id === values["authorId"])
        ?.shortDescription ||
      "";

    return (
      <SectionCard elevation={1}>
        <DayPlansHeader>
          <SectionHeader style={{ marginBottom: 0 }}>
            <ListAltIcon style={{ color: "#6366f1" }} />
            <div>
              <SectionTitle variant="h6">Day Plans</SectionTitle>
              <SectionSubtitle variant="body2">
                Organize the daily content for this plan
              </SectionSubtitle>
            </div>
          </SectionHeader>
          <DayPlansActions>
            {dayPlansCount > 0 && (
              <StatsChip
                size="small"
                label={`${dayPlansCount} day${dayPlansCount !== 1 ? "s" : ""}`}
              />
            )}
            <ImportDayPlan
              prevDayPlans={values.dayPlans}
              habitId={values.id}
              setDayPlans={(actions) => setFieldValue("dayPlans", actions)}
            />
            <ExportExcel
              values={dayPlansArray}
              title="Day Plans"
            />
          </DayPlansActions>
        </DayPlansHeader>
        <DayPlanTable
          authorID={values["authorId"]}
          planID={values["id"]}
          dayPlans={dayPlansArray}
          setFieldValue={setFieldValue}
          communityId={values["communityId"]}
          planTitle={values["title"]}
          planDescription={values["description"]}
          authorName={authorName}
          authorDescription={authorDescription}
        />
      </SectionCard>
    );
  };
  renderSubcategory = () => {
    const { values, setFieldValue } = this.props;
    // Subcategory only applies to workout plans. Detect via planType or the
    // categoryName written by the workout importer (legacy plans may lack
    // planType but still carry categoryName="Workout").
    const isWorkoutPlan =
      values?.planType === "exercise" ||
      (values?.categoryName || "").toLowerCase().trim() === "workout";
    if (!isWorkoutPlan) return null;
    const planType: PlanType = "exercise";
    const options = getSubcategoriesFor(planType);
    if (options.length === 0) return null;

    return (
      <SectionCard elevation={1}>
        <SectionHeader>
          <CategoryIcon style={{ color: "#6366f1" }} />
          <div>
            <SectionTitle variant="h6">Subcategory</SectionTitle>
            <SectionSubtitle variant="body2">
              Groups this plan under a section header in HabitDetailScreen.
            </SectionSubtitle>
          </div>
        </SectionHeader>
        <CategoryContainer>
          <FormControl variant="outlined" fullWidth size="small">
            <InputLabel id="plan-subcategory-label">Subcategory</InputLabel>
            <Select
              labelId="plan-subcategory-label"
              label="Subcategory"
              value={values?.subcategoryId || ""}
              onChange={(e) => {
                const id = e.target.value as string;
                const sub = findSubcategoryById(planType, id);
                setFieldValue("subcategoryId", sub?.id || "");
                setFieldValue("subcategoryName", sub?.name || "");
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {options.map((s) => (
                <MenuItem key={s.id} value={s.id}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </CategoryContainer>
      </SectionCard>
    );
  };
  renderCategories = () => {
    const { categories } = this.props;
    const { categoriesCreated } = this.state;
    const brandInputFieldData = getRowItemObject(
      "Category",
      "Enter the category",
      "text",
      "categoryName"
    );

    const brandData = {
      datasetCreatedId: "categoriesCreated",
      fieldData: brandInputFieldData,
      datasetCreated: categoriesCreated,
      dataset: categories,
      canCreateNewItem: true,
    };

    return (
      <SectionCard elevation={1}>
        <SectionHeader>
          <CategoryIcon style={{ color: "#6366f1" }} />
          <div>
            <SectionTitle variant="h6">Category</SectionTitle>
            <SectionSubtitle variant="body2">
              Assign a category to organize this plan
            </SectionSubtitle>
          </div>
        </SectionHeader>
        <CategoryContainer>
          <Row>{this.renderInputWithCreation(brandData)}</Row>
        </CategoryContainer>
      </SectionCard>
    );
  };
  onCreateItem = (itemCreated, id) => {
    const { item, categories, communityId } = this.props;
    const dataset = this.state.categoriesCreated;
    let updatedDataset: PlanCategory[] = [itemCreated.name, ...dataset];

    createCategory({
      communityId,
      name: itemCreated.name,
      position: categories.length + 1,
    }).then((id) => {
      updatedDataset = [
        {
          id,
          createdAt: new Date().getTime(),
          imageURL: "",
          isActive: true,
          name: itemCreated.name,
          position: categories.length + 1,
        },
        ...dataset,
      ];

      this.props.setFieldValue("categoryId", id);
      this.setState({ categoriesCreated: updatedDataset });
    });
  };
  renderInputWithCreation = (data: any) => {
    const { setFieldValue, errors, values, item, mode } = this.props;

    const {
      datasetCreatedId,
      datasetCreated,
      fieldData,
      dataset,
      canCreateNewItem,
      showDataset,
    } = data;

    const currentDataset = [...datasetCreated, ...dataset];

    return (
      <div style={{ flex: 1 }}>
        <InputWithCreation
          onCreateItem={(newItem: string): void =>
            this.onCreateItem(newItem, datasetCreatedId)
          }
          canCreateNewItem={true}
          dataset={currentDataset}
          setFieldValue={setFieldValue}
          showDataset={showDataset}
          fieldData={fieldData}
          errors={errors}
          values={values}
          item={item}
          mode={mode}
          id={fieldData.id}
        />
      </div>
    );
  };
  render() {
    const {
      onChageFormToEditMode,
      onRemoveItem,
      isSubmitting,
      mode,
    } = this.props;

    return (
      <div>
        <Wrapper>
          <Form>
            <FormContainer>
              {this.renderEventInfoSection()}
              {this.renderCategories()}
              {this.renderSubcategory()}
              {this.renderImageSection()}
              {this.renderDayPlan()}
            </FormContainer>
          </Form>
        </Wrapper>
        <ActionFormButton
          onChageFormToEditMode={onChageFormToEditMode}
          onClick={this.onSubmitForm}
          onRemoveItem={onRemoveItem}
          disabled={isSubmitting}
          entity="Plan"
          canBeRemoved
          mode={mode}
        />
      </div>
    );
  }
}

const CustomForm = withFormik({
  mapPropsToValues: (props: any): Plan => {
    const { item, mode } = props;
    const dayPlans = Object.values(item.dayPlans || []).map((dayPlan: DayPlan) => ({
      ...dayPlan,
      steps: [...(dayPlan?.steps || [])],
    }));

    return {
      id: item.id || "",
      title: item.title || "",
      shortDescription: item.shortDescription || "",
      description: item.description || "",
      coverImageURL: item.coverImageURL || "",
      createdAt: item.createdAt || Date.now().toString(),
      categoryId: item.categoryId || "",
      categoryName: item.categoryName || "",
      subcategoryId: item.subcategoryId || "",
      subcategoryName: item.subcategoryName || "",
      planType: item.planType || undefined,
      isActive: item.isActive || false,
      dayPlans,
      authorId: item.authorId || "",
      authorName: item.authorName || "",
      position: item.position || 0,

      author: item.author || null,
      stepsCount: item.stepsCount || 0,
      level: item.level || "",
      learningVariantGroupId: item.learningVariantGroupId || "",
      communityId: item?.communityId || "",
    };
  },

  validationSchema: ({ item, plans = [] }) => {
    return Yup.lazy(() =>
      Yup.object().shape({
        title: Yup.string().required("El nombre es requerido."),
        description: Yup.string().required("La descripción es requerida."),
        learningVariantGroupId: Yup.string()
          .trim()
          .max(80, "Use 80 characters or fewer for the family id.")
          .matches(
            /^[A-Za-z0-9_-]*$/,
            "Use only letters, numbers, hyphens, and underscores."
          )
          .test(
            "learning-variant-level",
            "Choose Beginner, Intermediate, or Advanced for a difficulty variant.",
            function (groupId) {
              if (!groupId) return true;
              return PLAN_LEVEL_OPTIONS.some(
                (option) =>
                  option.id === String(this.parent.level || "").toUpperCase()
              );
            }
          )
          .test(
            "learning-variant-plan-type",
            "Difficulty variants are only available for learning plans.",
            function (groupId) {
              if (!groupId) return true;
              return (
                this.parent.planType !== "exercise" &&
                this.parent.categoryId !== "workout"
              );
            }
          )
          .test(
            "learning-variant-level-unique",
            "This family already has a plan at the selected level.",
            function (groupId) {
              const normalizedGroupId = String(groupId || "").trim();
              if (!normalizedGroupId) return true;
              const normalizedLevel = String(
                this.parent.level || ""
              ).toUpperCase();
              return !plans.some(
                (plan: Plan) =>
                  plan.id !== item?.id &&
                  String(plan.learningVariantGroupId || "").trim() ===
                    normalizedGroupId &&
                  String(plan.level || "").toUpperCase() === normalizedLevel
              );
            }
          ),
        // startTime: Yup.object().required("La fecha de inicio es requerida."),
        //price: Yup.number().required("El precio es requerido."),
      })
    );
  },

  handleSubmit(values, { setSubmitting, props }) {
    const { onCreateItem, onEditItem, mode } = props;

    const properCallback = mode === "edit" ? onEditItem : onCreateItem;

    //@ts-ignore
    if (mode === "create")
      values = { ...values, createdAt: new Date().getTime().toString() };

    const learningVariantGroupId = String(
      values.learningVariantGroupId || ""
    ).trim();
    if (learningVariantGroupId) {
      values = {
        ...values,
        learningVariantGroupId,
        level: String(values.level || "").toUpperCase(),
      };
    } else {
      delete values.learningVariantGroupId;
    }

    let numberOfSteps = 0;
    Object.values(values.dayPlans).map((dayPlan: DayPlan) => {
      if (!!dayPlan.steps)
        numberOfSteps = numberOfSteps + Object.values(dayPlan.steps).length;
    });

    values = { ...values, stepsCount: numberOfSteps };

    //values.authorId = values.author.id;
    //@ts-ignore
    if (!!values.category) values.categoryId = values.category.id;

    console.log("[PlanForm] handleSubmit -> saving", {
      mode,
      authorId: values.authorId,
      authorName: values.authorName,
      author: values.author,
      payload: values,
    });

    properCallback({
      ...values,
    });

    setSubmitting(false);
  },
  enableReinitialize: true,
})(UserForm);

export default CustomForm;
